module.exports = __webpack_public_path__ + "7588d76faf077fbce89d6c8b4ac3bb29.svg";